import React from 'react';
import { Link } from 'react-scroll';

const VehicleSection = () => {
  return (
    <section id="services" className="bg-black py-24">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl underline font-bold text-orange-500 mb-8">Range of Vehicles</h2>
        <p className="text-gray-300 text-2xl mb-12">
          We have a wide range of well-maintained vehicles.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Vehicle Card Template */}
          {[
            {
              img: '/fortuner.jpeg',
              name: 'Fortuner 8+1',
              price: 'Rs. 7000 /day',
              seats: '8+1',
              seatCount: '8 Seats',
            },
            {
              img: '/ertiga.jpeg',
              name: 'Ertiga (6+1)',
              price: 'Rs. 2700 /day',
              seats: '6+1',
              seatCount: '6 Seats',
            },
            {
              img: '/n.jpeg',
              name: 'Scorpio N 8+1',
              price: 'Rs. 5000 /day',
              seats: '8+1',
              seatCount: '8 Seats',
            },
            {
              img: '/innova.png',
              name: 'Innova (6+1)',
              price: 'Rs. 5500 /day',
              seats: '6+1',
              seatCount: '6 Seats',
            },
            {
              img: '/dzire.jpeg',
              name: 'Dzire (4+1)',
              price: 'Rs. 2000 /day',
              seats: '4+1',
              seatCount: '4 Seats',
            },
            {
              img: '/scorpio.jpeg',
              name: 'Scorpio (6+1)',
              price: 'Rs. 5000 /day',
              seats: '6+1',
              seatCount: '6 Seats',
            },
            {
              img: '/celerio.png',
              name: 'Celerio (4+1)',
              price: 'Rs. 1500 /day',
              seats: '4+1',
              seatCount: '4 Seats',
            },
            {
              img: '/thar.jpeg',
              name: 'Thar (4+1)',
              price: 'Rs. 5000 /day',
              seats: '4+1',
              seatCount: '4 Seats',
            },
          ].map((vehicle, index) => (
            <div key={index} className="p-4">
              <div className="border border-orange-500 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
                <img
                  src={vehicle.img}
                  alt={vehicle.name}
                  className="w-full h-60 object-cover mb-4 rounded-t-lg transition-transform duration-300 hover:scale-105"
                />
                <h3 className="text-xl font-semibold mb-2 text-white">{vehicle.name}</h3>
                <p className="text-gray-300">{vehicle.price}</p>
                <Link
                  to="footer"
                  smooth={true}
                  duration={500}
                  className="bg-orange-500 text-white font-semibold px-4 py-2 mt-4 inline-block rounded hover:bg-orange-600 transition"
                >
                  Book Now
                </Link>
                <div className="flex justify-between mt-4 bg-orange-500 text-white p-2 text-sm rounded-b-lg">
                  <span>{vehicle.seats}</span>
                  <span>{vehicle.seatCount}</span>
                  <span>AC</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehicleSection;
